export var TABLE_STYLE = {
  'border-collapse': 'collapse',
  margin: '1.2rem 0',
  width: '100%'
};